<template>
    <div >
   <div ref="mapOption1" class="line1" id="line1"></div>
   </div>
  </template>
  
  <script>
  import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
  import Pagination from 'components/pagination';
  // 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
  // import * as echarts from 'echarts/core';
  // 引入柱状图图表，图表后缀都为 Chart
  // import { BarChart } from 'echarts/charts';
  
  export default {
    name: 'reportList',
    computed: {
        ...mapState('report',['echartsData'])
    },
    components: {
      Pagination
    },
    mounted () {
     console.log('ddd',this.echartsData);
    // this.showChart()

    },
    created () {
    // this.getTurnover({ 
    // endTime: '1663603200000',
    // startTime: '1662912000000',
    // symbol: "",
    // type: 0})
  },
    methods: {
        ...mapActions('report',['getTurnover']),

      showChart() {
              // (1)初始化echarts
              const mychart = this.$echarts.init(this.$refs.mapOption1);
              const option = {
                        color: ['#80FFA5', '#00DDFF', '#37A2FF', '#FF0087', '#FFBF00'],
                        title: {
                        text: ''
                        // text: '交易人数 \n 总人数'
                        },
                        tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                            backgroundColor: '#6a7985'
                            }
                        }
                        },
                        legend: {
                        data: ['显示'],
                        // left:'auto',
                        top:20
                        },
                        toolbox: {
                        feature: {
                            saveAsImage: {}
                        }
                        },
                        grid: {
                        left: '2%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                        },
                        xAxis: [
                        {
                            type: 'category',
                            boundaryGap: false,
                            data: [],
                            "axisLine":{"show":false},//隐藏x轴线
                            "axisTick":{"show":false},//隐藏x轴刻度
                        }
                        ],
                        yAxis: [
                        {
                            show: false,
                            type: 'value',
                            // name:''
                            "axisLine":{"show":false},//隐藏Y轴线
                            "aYisTick":{"show":false},//隐藏Y轴刻度
                        }
                        ],
                        series: [
                        {
                            name: '显示',
                            type: 'line',
                            stack: 'Total',
                            smooth: true,
                            lineStyle: {
                            width: 0
                            },
                            showSymbol: false,
                            areaStyle: {
                            opacity: 0.8,
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {
                                offset: 0,
                                color: 'rgb(10, 25, 165)'
                            },
                            {
                                offset: 1,
                                color: 'rgb(1, 111, 236)'
                            }
                            ])
                            },
                            emphasis: {
                            focus: 'series'
                            },
                            data: [20, 188932, 11, 64, 171990, 40, 25,118554,36]
                        }
                        ]
                    };
              mychart.setOption(option);
              window.addEventListener("resize", () => {
             	mychart.resize();
            })
          },
        
     
    }
  };
  </script>
  
  <style lang="less" scoped>
    
      .line1{
        width: 100%;
        height: 200px;
        cursor: pointer !important;
        border-top: 1px solid whitesmoke;
        // box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
        // :hover{
        //     box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);
        // }
      }
  </style>
  